import IBaseListingResponse from "../../utils/api/base-listing-response";
import {IDonation, IDonationDetails} from "../../models/donation/response";
import {IDonationQuery} from "../../models/donation/query";
import {DEFAULT_FUNCTION, DEFAULT_QUERY} from "../../utils/helpers/constants";
import {createContext} from "react";

export type DonationLoading =
    | "list"
    | "details";

export interface IInternalState {
  loading: DonationLoading[];
  list?: IBaseListingResponse<IDonation>;
  query: IDonationQuery;
  details?: IDonationDetails;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getDetails: (id: number) => void;
    setDetails: (data?: IDonationDetails) => void;
    setSearch: (search?: string) => void;
    setQuery: (query: IDonationQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    setDetails: DEFAULT_FUNCTION,
    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const DonationContext = createContext(externalState);

export default DonationContext;